import { takeEvery, all } from 'redux-saga/effects';
import { commonTypes } from '../actions';

function* initialize() {}

export default function* CommonSagas() {
	yield all([ takeEvery(commonTypes.INITIALIZE, initialize) ]);
}
